import { useEffect, useState } from "react";
import { fetchFichasClinicas } from "../services/user";
import { useUserState } from "../state/user";

export default function useFichaClinica() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useUserState();

  useEffect(() => {
    (async function() {
      try {
        setLoading(true);
        if (!token) return;
        const result = await fetchFichasClinicas(token);
        setData(result);
      } catch (err) {
        setError(err as any);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  return { data, error, loading };
}
